import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="gallery-select"
// Handles the gallery selection modal with tabs and item selection
export default class extends Controller {
  static targets = ["tab", "panel"];
  static values = {
    fieldId: String
  };

  connect() {
    // Controller connected - tabs are ready
  }

  showTab(event) {
    const selectedTab = event.currentTarget;
    const tabName = selectedTab.dataset.tab;

    // Hide all panels
    this.panelTargets.forEach(panel => {
      panel.classList.add("hidden");
    });

    // Show selected panel
    const selectedPanel = this.panelTargets.find(panel => panel.dataset.tab === tabName);
    if (selectedPanel) {
      selectedPanel.classList.remove("hidden");
    }

    // Update tab styles
    this.tabTargets.forEach(tab => {
      tab.classList.remove("border-blue-500", "text-blue-600");
      tab.classList.add("border-transparent", "text-stone-500");
    });

    selectedTab.classList.remove("border-transparent", "text-stone-500");
    selectedTab.classList.add("border-blue-500", "text-blue-600");
  }

  selectItem(event) {
    const button = event.currentTarget;
    const item = {
      type: button.dataset.itemType,
      url: button.dataset.itemUrl,
      id: button.dataset.itemId,
      thumbnail: button.dataset.itemThumbnail,
      filename: button.dataset.itemFilename,
      width: button.dataset.itemWidth ? parseInt(button.dataset.itemWidth) : null,
      height: button.dataset.itemHeight ? parseInt(button.dataset.itemHeight) : null
    };

    // Find the gallery picker controller element
    const pickerElement = document.getElementById("gallery-picker-" + this.fieldIdValue);
    if (!pickerElement) {
      console.error("Gallery picker not found for field:", this.fieldIdValue);
      return;
    }

    // Get the Stimulus controller instance
    const controller = this.application.getControllerForElementAndIdentifier(pickerElement, "gallery-picker");
    if (!controller) {
      console.error("Gallery picker controller not found");
      return;
    }

    // Call the addItem method on the controller
    const added = controller.addItem(item);

    // Update the button to show it was added
    if (added !== false) {
      const originalText = button.textContent;
      button.textContent = "Added!";
      button.classList.remove("bg-stone-600", "hover:bg-stone-500");
      button.classList.add("bg-green-600", "hover:bg-green-500");

      setTimeout(() => {
        button.textContent = originalText;
        button.classList.remove("bg-green-600", "hover:bg-green-500");
        button.classList.add("bg-stone-600", "hover:bg-stone-500");
      }, 1000);
    }
  }
}
